import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { Widget } from '../../../../Widget'
import { RentalPortalBlockDisabledEditButton } from '../../../RentalPortalBlockDisabledEditButton'
import { useApplicantProfileContext } from '../../RentalPortalApplicantProfile.hooks'
import { getIsApplicantWidgetSkeleton } from '../RentalPortalApplicantProfileTabOverview.utils'

import { QA_NAME_APPLICANT_IDENTITY_WIDGET } from './ApplicantIdentityWidget.constants'
import { getApplicantIdentityEditState } from './ApplicantIdentityWidget.utils'
import { ApplicantIdentityWidgetContent } from './ApplicantIdentityWidgetContent'

function ApplicantIdentityWidget() {
  const { t } = useTranslation()

  const { applicantData, isInitiated, isPreview } = useApplicantProfileContext()

  const { isHidden, tooltipKey } = getApplicantIdentityEditState({
    applicantData,
    isPreview,
  })

  const editActionsProps = tooltipKey
    ? {
        EditButton: RentalPortalBlockDisabledEditButton,
        editButtonProps: { tooltipKey },
      }
    : EMPTY_OBJECT

  return (
    <Widget
      headerProps={{
        contentProps: {
          actionsProps: isHidden ? { EditButton: null } : editActionsProps,
        },
      }}
      isSkeleton={getIsApplicantWidgetSkeleton({ applicantData, isInitiated })}
      qaName={QA_NAME_APPLICANT_IDENTITY_WIDGET}
      title={t('RentalPortal.ApplicantProfileIdentityTitleKey')}
    >
      <ApplicantIdentityWidgetContent />
    </Widget>
  )
}

export default ApplicantIdentityWidget
